
import React, { useEffect, useState } from 'react';
import {isNumeric,isMonthAndYearEmpty,getStatusFlagValue,getButtonDisabledStates} from '../Custom/Custom'
import messages from '../assets/Messages.json'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from '../Constant';
import { GlobalLoading, showLoading } from 'react-global-loading'


function PriceAgricultureParityFormforBullData({
  priceAgrilcultureData,
  districtCode,
  config,
  userInfoObject,
  yearName,
  monthName,
  resetMothAndYearField
  
}) {



  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);


  useEffect(() => {
    const initialData = {};

    priceAgrilcultureData.forEach(item => {
         initialData[item.marketCode] = {
               baseYear: item.baseYear,
               marketCode: item.marketCode,
               districtCode: item.districtCode,
               statusFlag: item.statusFlag,
               variance: item.variance,
               marketName: item.marketName,
               desiBellPrice: item.desiBellPrice,
               gradedBellPrice: item.gradedBellPrice,
               remark: item.remark,
              //  remark: item.remark,
        
            style: {
              borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
              borderStyle: 'solid',
              borderWidth: '1px 1px 1px 3px'
            },
            isRequiredRemark:false,
            isRejectStatus:false
            
          };
      
    });
    setItemData(initialData);


    if (
      priceAgrilcultureData[0].statusFlag === "0" ||
      priceAgrilcultureData[0].statusFlag === "2" ||
      priceAgrilcultureData[0].statusFlag === "6" ||
      priceAgrilcultureData[0].statusFlag === "8"
    ) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

  }, [priceAgrilcultureData]);

// Table Header
const renderHeader = (i) => (
  <thead key={`thead-${i}`}>
    <tr>
      <th>Serial No.</th>
      <th>Market Name</th>
      <th>Desi Bull Price</th>
      <th>Greaded bull Price</th>
      <th>Remarks</th>
    
    </tr>
  </thead>
); 


//handle  onChange
const handleOnChange = (itemCode, field, newValue) => {

  if (!(isMonthAndYearEmpty(monthName, yearName))) {
    return;
  }
  let isRequiredRemark = false;

  if ((field === 'desiBellPrice' || field === 'gradedBellPrice' ) && !isNumeric(newValue)) {
    toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
    newValue = '';
  }

  if (field === 'remark' && itemData[itemCode].isRequiredRemark === false
    && newValue === '' && itemData[itemCode].remark === '') {
    isRequiredRemark = true
  }

  setItemData(prevItemData => {
    const updatedItemData = {
      ...prevItemData,
      [itemCode]: {
        ...prevItemData[itemCode],
        [field]: newValue,
        'isRequiredRemark': isRequiredRemark
      }
    };

    return updatedItemData;
  });


};


//handle variation calculation
const handleValidateItemVariationPrice = (itemCode, field, newValue, average, variation) => {

  if (!(isMonthAndYearEmpty(monthName, yearName))) {
    return;
  }
  
  let dynamicStylesForTextBox = {}
  let isRequiredRemark = false

  if (newValue !== 0) {
    let dif = average * variation / 100;
     if (variation === 0 || dif === 0) {
      return;
    }
    if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
      toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
      dynamicStylesForTextBox = {
        borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
        borderStyle: 'solid',
        borderWidth: '1px 1px 1px 6px'
      }
      newValue = dynamicStylesForTextBox
      if (itemData[itemCode].remark === 'NQ' || itemData[itemCode].remark === '') {
        isRequiredRemark = true
      }


    } else {

      dynamicStylesForTextBox = {
        borderColor: '#dcdfe1',
        borderStyle: 'solid',
        borderWidth: '1px 1px 1px 6px'
      }
      isRequiredRemark = false
      newValue = dynamicStylesForTextBox


    }
  }


  setItemData(prevItemData => ({
    ...prevItemData,
    [itemCode]: {
      ...prevItemData[itemCode],
      [field]: newValue,
      'isRequiredRemark': isRequiredRemark
    }
  }));

}

const resetForm = () => {
  resetMothAndYearField()
}



const handleSavePriceAgricultureParityFormforBullData=async(e, buttonType)=>{
    const customItemCodes = [];
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
      return;
    }



    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel) //button click status flag
    for (let marketCodeId in itemData) {
      let desiBellPrice = itemData[marketCodeId].desiBellPrice;
      let gradedBellPrice = itemData[marketCodeId].gradedBellPrice;
      let marketCode = itemData[marketCodeId].marketCode;
      let statusFlag =clickButtonStatusFlag;
      let remark=itemData[marketCodeId].remark;
      let isRequiredRemark = itemData[marketCodeId].isRequiredRemark;
      let marketName=itemData[marketCodeId].marketName;

      if (isRequiredRemark && remark === 'NQ') {
        toast.error(messages.REMARK_MSG, messages.COLOR_RED);
        return false;
      }

      if (remark === '' || remark == null) {
        remark = '';
      }

      const customObject = {
        desiBellPrice: desiBellPrice,
        gradedBellPrice: gradedBellPrice,
        marketCode: marketCode,
        statusFlag: statusFlag,
        remark:remark,
        marketName:marketName
        
      
     };
    customItemCodes.push(customObject);
}


    let postData = {
      itemCodes: customItemCodes,
      payload: {
        monthName: monthName,
        yearName: yearName,
        districtCode: districtCode,
        buttonType: buttonType,
        statusButtonFlag:clickButtonStatusFlag
      }
    };
    // return false;

    showLoading(true)
    try {

    const response = await axios.post(`${API_URL}api/otherPrices/PriceAgricultureParityBullWithDataSaveToDB`, postData, config);
        if (response.data.status) {
            toast.success(response.data.message, messages.COLOR_RED);
        }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
      resetForm();
    }

}
 

  return (
      <>
    {/* <ToastContainer/> */}
    <div className="card-body">
        <div className="table-responsive">
          <table  className="table table-bordered">
            {renderHeader(0)}
            <tbody>
           {priceAgrilcultureData && priceAgrilcultureData.map((item,i)=>{

    return (
               <tr key={i}>
              <td>
               {++i}
              </td>

              <td >
                <input
                type='text'
                className="form-control"
                name={`marketName_${i}`}
                id={`marketName_${i}`} 
                value={itemData[item.marketCode]?.marketName}
                disabled
                />
              </td>

              <td>
              <input
                type='text'
                className="form-control"
                style={itemData[item.marketCode]?.desiBellPriceStyle || {}}
                name={`desiBellPrice_${i}`}
                id={`desiBellPrice_${i}`}
                value={itemData[item.marketCode]?.desiBellPrice}
                onChange={e => handleOnChange(item.marketCode, 'desiBellPrice', e.target.value)}
                onBlur={e => handleValidateItemVariationPrice(item.marketCode, 'desiBellPriceStyle', parseFloat(e.target.value), item.avgdesiBellPrice, item.variance)}
                maxLength='12'
                />
              </td>

              <td>
              <input
                type='text'
                className="form-control"
                name={`gradedBellPrice_${i}`}
                id={`gradedBellPrice_${i}`}
                style={itemData[item.marketCode]?.gradedBellPriceStyle || {}}
                value={itemData[item.marketCode]?.gradedBellPrice}
                onChange={e => handleOnChange(item.marketCode, 'gradedBellPrice', e.target.value)}
                onBlur={e => handleValidateItemVariationPrice(item.marketCode, 'gradedBellPriceStyle', parseFloat(e.target.value), item.avggradedBellPrice, item.variance)}
                maxLength='12'
                />
              </td>

              <td>

                {
                  item.remark === 'NQ'  && 
                 <label className="text-danger" style={{ fontSize: '12px' }}>* {item.remark}</label>
          
                }
              <select 
              className="form-select" 
              name={`remark_${i}`}
              id={`remark${i}`}
              value={itemData[item.marketCode]?.remark || ''}
              onChange={e => handleOnChange(item.marketCode, 'remark', e.target.value)}
              >
              <option value="">[---Select---]</option>
              <option value="Price is Too Low.">Price is Too Low.</option>
              <option value="Price is too High.">Price is too High.</option>
              <option value="Price does not match with unit.">Price does not match with unit.</option>
              <option value="Price does not match with variety.">Price does not match with variety.</option>
              <option value="Others.">Others.</option>
            </select>

              </td>

              </tr>
      )})

           }
               
           </tbody>
        </table>
          </div>

        <div className="row">
          <div className="col-12 text-center pt-3">
            
              <button
                onClick={(e) => handleSavePriceAgricultureParityFormforBullData(e, 'SAVE')}
                type="button"
                className="btn btn_orange mx-1"
                disabled={isDisabled}
              >Save
              </button>
            

            

              <button
                onClick={(e) => handleSavePriceAgricultureParityFormforBullData(e, 'ACCEPT')}
                type="submit"
                className="btn btn_orange mx-1"
                disabled={isDisabled}
              >Submit
              </button>
           
          

              <button 
                type="reset" 
                className="btn btn_orange mx-1" 
                onClick={resetForm} 
                >
                Reset
              </button>
              <button 
                type="button" 
                className="btn btn_orange mx-1" 
                onClick={(e)=>( navigate("/dashboard"))}
                >
                Cancel
              </button>
          </div>
        </div>

        </div>
      </>
  )
}

export default PriceAgricultureParityFormforBullData